import { TrendingUp, X, History, Package } from "lucide-react";

/**
 * Upsell suggestions strip displayed under the estimate line builder.
 * Each suggestion carries a reason (rule / customer_history / catalog)
 * shown as a badge. Clicking "+ Add" appends the corresponding line.
 */
export default function UpsellStrip({ suggestions, onAdd, onDismiss, dismissed }) {
  const visible = (suggestions || []).filter((s) => !dismissed.has(s.service_id));
  if (visible.length === 0) return null;
  return (
    <div className="bg-white border border-zinc-200 rounded-xl p-4 card-crisp" data-testid="upsell-strip">
      <div className="flex items-center gap-2 mb-3">
        <TrendingUp className="w-4 h-4 text-[#FF5A00]" />
        <div className="font-heading font-bold">Recommended add-ons</div>
        <span className="ml-auto text-xs text-zinc-500 font-mono-accent">{visible.length}</span>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-2">
        {visible.map((s) => (
          <div
            key={s.service_id}
            className="border border-zinc-200 rounded-lg p-3 flex items-start gap-2"
            data-testid={`upsell-card-${s.service_id}`}
          >
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium truncate">{s.service_name}</div>
              <div className="text-[10px] font-mono-accent mt-0.5 flex items-center gap-1">
                <ReasonBadge reason={s.reason} />
                {s.note && <span className="text-zinc-400 truncate">· {s.note}</span>}
              </div>
              <div className="text-xs text-zinc-600 font-mono-accent mt-1">
                {s.unit_price ? `$${Number(s.unit_price).toFixed(2)}/${s.unit || "unit"}` : `$${Number(s.default_price || 0).toFixed(2)}`}
              </div>
            </div>
            <div className="flex flex-col items-end gap-1">
              <button
                onClick={() => onAdd(s)}
                className="text-xs bg-[#FF5A00] hover:bg-[#E04F00] text-white px-2 py-1 rounded"
                data-testid={`upsell-add-${s.service_id}`}
              >
                + Add
              </button>
              <button
                onClick={() => onDismiss(s.service_id)}
                className="text-zinc-400 hover:text-zinc-900"
                aria-label="Dismiss"
                data-testid={`upsell-dismiss-${s.service_id}`}
              >
                <X className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function ReasonBadge({ reason }) {
  const map = {
    rule: { label: "RULE", cls: "text-[#FF5A00] bg-orange-50", icon: TrendingUp },
    customer_history: { label: "PAST JOB", cls: "text-indigo-700 bg-indigo-50", icon: History },
    catalog: { label: "CATALOG", cls: "text-zinc-600 bg-zinc-100", icon: Package },
  };
  const m = map[reason] || map.catalog;
  const Icon = m.icon;
  return (
    <span className={`px-1.5 py-0.5 rounded uppercase tracking-widest inline-flex items-center gap-1 ${m.cls}`}>
      <Icon className="w-2.5 h-2.5" /> {m.label}
    </span>
  );
}
